<ng-progress></ng-progress>
<section class="login-wrapper">
  <div *ngIf="!isMobile" class="col-md-9 float-left padding-0">
    <app-banner [banners]="banners"></app-banner>
  </div>

  <div class="col-md-3 float-right login-form p-r-0">

    <mat-card>
      <mat-card-content>
        <div class=" col-md-12 brand-logo">
          <ng-container *ngIf="brandLogo">
            <img [src]="brandLogo.imageUrl" />
          </ng-container>
        </div>
        <router-outlet></router-outlet>
        <div class="col-md-12 sub-brand-logo"
          *ngIf="appLogo"><img [src]="appLogo.imageUrl" /></div>

      </mat-card-content>
    </mat-card>
  </div>
</section>
